import { render, staticRenderFns } from "./uploadBigFile.vue?vue&type=template&id=adbace72"
import script from "./uploadBigFile.vue?vue&type=script&lang=js"
export * from "./uploadBigFile.vue?vue&type=script&lang=js"
import style0 from "./uploadBigFile.vue?vue&type=style&index=0&id=adbace72&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports